import React from 'react';
import MaybeStackedButtons, { MaybeStackedButtonsProps } from '../../MaybeStackedButtons';

export type GateButtonsOwnProps = {};

export type GateButtonsProps = GateButtonsOwnProps & MaybeStackedButtonsProps;

const TOP_MARGIN = 40;

const GateButtons: React.FC<GateButtonsProps> = (props) => {
    return <MaybeStackedButtons {...props} style={[props.style, { marginTop: TOP_MARGIN }]} />;
};

export default React.memo(GateButtons);
